import { IconButton, Flex, CloseIcon } from '@buffer-mono/popcorn'
import type { AutocompleteItem } from '../../types'
import styles from './AutocompleteSuggestion.module.css'
import {
  getRecentItems,
  isRecentItem,
  removeRecentItem,
} from '../../../linkedin-annotations/queries/recentSuggestions'
import { comboboxActions } from '@udecode/plate'

export const AutocompleteSuggestion = ({
  mention,
}: {
  mention: AutocompleteItem
}): JSX.Element => {
  const { avatar, name, handle } = mention.data

  const isRecentSuggestion = isRecentItem(mention.key)

  return (
    <Flex fullWidth align="center" justify="between">
      {avatar ? (
        <img className={styles.avatar} src={avatar} alt="" />
      ) : (
        <div className={styles.emptyAvatar}>{name ? name[0] : ''}</div>
      )}
      <span className={styles.text}>
        {name && <span className={styles.name}>{`${name} `}</span>}
        {handle}
      </span>

      {isRecentSuggestion && (
        <IconButton
          className={styles.action}
          label="Remove recent suggestion"
          variant="tertiary"
          size="small"
          onMouseDown={(e): void => {
            e.preventDefault()
            e.stopPropagation()

            const successfullyRemovedRecentItem = removeRecentItem(mention.key)

            if (successfullyRemovedRecentItem) {
              const remainingRecentSuggestionItems = getRecentItems()

              if (remainingRecentSuggestionItems?.length) {
                // Update list of recent suggestions
                comboboxActions.items(remainingRecentSuggestionItems)
              } else {
                // Close the list
                comboboxActions.reset()
              }
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Flex>
  )
}
